import React from 'react';
import EmptyInfluencerComponent from './EmptyInfluencerComponent';
import InfluencerCardComponent from './InfluencerCardComponent';
import './OpenedInfluencerListComponent.styles.scss';

const OpenedInfluencerListComponent = ({ list, setListLoadingData }) => {
  return (
    <div className="d-flex flex-wrap">
      {/* <div className="col-md-4">
                <div className="common_card">
                    user card
                </div>
            </div> */}
      {list[0].influencer_ids.length ?
        list[0].influencer_ids.map((influencer)=>(
          <InfluencerCardComponent key={influencer.id}
            {...influencer}
            allowRemoveList
            listId={list[0]._id}
            setListLoadingData={setListLoadingData}/>
        )):
        <EmptyInfluencerComponent button>No Influencers added to this list. Please add your Influencers from Discovery page</EmptyInfluencerComponent>
      }
      {/* <InfluencerCardComponent/> */}
    </div>
  );
};

export default OpenedInfluencerListComponent;
